(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  function getDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  /*
   * Read the IDs off the DOM rather than hardcoding them: a section inside a
   * section group is addressed by its own name ("cart-drawer"), but one in a
   * JSON template gets a generated ID ("template--123__main"). Liquid already
   * printed the right one into the attribute.
   *
   * The API answers 400 and renders nothing past five sections, so cap it.
   */
  function getSectionIds() {
    return Array.from(document.querySelectorAll('[data-cart-section]'))
      .map((element) => element.dataset.cartSection)
      .filter(Boolean)
      .slice(0, 5)
      .join(',');
  }

  function syncCount() {
    const source = document.querySelector('[data-cart-item-count]');

    if (!source) return;

    const value = source.textContent.trim();

    document.querySelectorAll('[data-cart-count]').forEach((element) => {
      element.textContent = value;
    });
  }

  /*
   * Replacing innerHTML throws away the focused control, which strands keyboard
   * and screen reader users at the top of the document mid-interaction. The key
   * plus the control's role is enough to find the same button again in the new
   * markup, so record it before the swap and restore it after.
   */
  function captureFocus() {
    const active = document.activeElement;

    if (!active || !active.dataset || !active.dataset.cartKey) return null;

    if (active.dataset.cartStep) {
      return `[data-cart-step="${active.dataset.cartStep}"][data-cart-key="${active.dataset.cartKey}"]`;
    }

    if ('cartQuantity' in active.dataset) {
      return `[data-cart-quantity][data-cart-key="${active.dataset.cartKey}"]`;
    }

    return null;
  }

  function restoreFocus(selector) {
    const target = selector ? document.querySelector(selector) : null;

    if (target) {
      target.focus();
      return;
    }

    /*
     * The control is gone, which means the line it belonged to was removed.
     * Only the drawer has somewhere obvious to send focus next; on the cart
     * page the browser's own handling is less surprising than a jump.
     */
    const drawer = getDrawer();

    if (!drawer || !drawer.open) return;

    const fallback = drawer.querySelector('[data-cart-drawer-close]');

    if (fallback) fallback.focus();
  }

  function applySections(sections) {
    if (!sections) return;

    const selector = captureFocus();

    Object.keys(sections).forEach((id) => {
      const html = sections[id];
      const target = document.querySelector(`[data-cart-section="${id}"]`);

      if (!target || typeof html !== 'string') return;

      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const next = parsed.querySelector(`[data-cart-section="${id}"]`);

      if (next) target.innerHTML = next.innerHTML;
    });

    syncCount();
    restoreFocus(selector);
  }

  function openDrawer() {
    const drawer = getDrawer();

    if (drawer && !drawer.open && typeof drawer.showModal === 'function') {
      drawer.showModal();
    }
  }

  /*
   * Every failure path falls back to the server-rendered cart rather than
   * leaving the customer looking at a stale drawer that silently ignored them.
   */
  async function changeLine(key, quantity) {
    const drawer = getDrawer();

    if (!drawer || !key) return;

    const url = drawer.dataset.changeUrl;

    if (!url) return;

    drawer.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: getSectionIds() }),
      });

      if (!response.ok) throw new Error('Cart change failed');

      const data = await response.json();

      drawer.removeAttribute('aria-busy');
      applySections(data.sections);
    } catch (error) {
      window.location.href = drawer.dataset.cartUrl || '/cart';
    }
  }

  async function addToCart(form) {
    const drawer = getDrawer();

    if (!drawer) return;

    const url = drawer.dataset.addUrl;

    if (!url) return;

    const submitter = form.querySelector('[type="submit"]');
    const body = new FormData(form);

    body.append('sections', getSectionIds());
    drawer.setAttribute('aria-busy', 'true');

    if (submitter) submitter.setAttribute('disabled', '');

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body,
      });

      if (!response.ok) throw new Error('Add to cart failed');

      const data = await response.json();

      drawer.removeAttribute('aria-busy');

      if (submitter) submitter.removeAttribute('disabled');

      applySections(data.sections);
      openDrawer();
    } catch (error) {
      if (submitter) submitter.removeAttribute('disabled');
      form.submit();
    }
  }

  document.addEventListener('submit', (event) => {
    const form = event.target;

    if (!(form instanceof HTMLFormElement)) return;

    const action = form.getAttribute('action') || '';

    if (action.indexOf('/cart/add') === -1) return;
    if (!getDrawer()) return;

    event.preventDefault();
    addToCart(form);
  });

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cart-drawer-open]');

    if (opener) {
      const drawer = getDrawer();

      if (drawer && typeof drawer.showModal === 'function') {
        event.preventDefault();
        openDrawer();
      }

      return;
    }

    const closer = event.target.closest('[data-cart-drawer-close]');

    if (closer) {
      const drawer = closer.closest('[data-cart-drawer]');

      if (drawer) drawer.close();

      return;
    }

    const remove = event.target.closest('[data-cart-remove]');

    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.cartKey, 0);
      return;
    }

    const step = event.target.closest('[data-cart-step]');

    if (step) {
      const input = step.parentElement.querySelector('[data-cart-quantity]');

      if (!input) return;

      const next = Math.max(0, (Number(input.value) || 0) + Number(step.dataset.cartStep));

      changeLine(step.dataset.cartKey, next);
      return;
    }

    if (event.target.matches('[data-cart-drawer]')) {
      event.target.close();
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-cart-quantity]');

    if (!input) return;

    changeLine(input.dataset.cartKey, Math.max(0, Number(input.value) || 0));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Headroom-style behaviour: the bar gets out of the way going down the page
  // and comes back on the way up. `is-pinned` marks "scrolled past the header",
  // which is what turns the stacked homepage header into a solid bar.
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header = this.querySelector('.header');

      if (!this.header) return;

      this.lastY = window.scrollY;
      this.onScroll = this.onScroll.bind(this);
      window.addEventListener('scroll', this.onScroll, { passive: true });
      this.onScroll();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
    }

    onScroll() {
      const y = Math.max(0, window.scrollY);
      const delta = y - this.lastY;

      // Ignore sub-pixel and rubber-band noise, which would otherwise flip the
      // direction on every frame.
      if (Math.abs(delta) < 4) return;

      const past = y > this.header.offsetHeight;

      this.header.classList.toggle('is-pinned', past);
      this.header.classList.toggle('is-hidden', past && delta > 0);
      this.lastY = y;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  // A filter pill points at another collection, so following it is a full
  // navigation and the browser drops the visitor back at the top of the page.
  // Fetching just this section through the Section Rendering API and swapping
  // it in leaves the scroll position exactly where it was.
  //
  // The listener is on the document rather than on the pills, so it survives
  // the swap and does not care that the pills live in a different section.
  (() => {
    const GRID = '[data-collection-grid]';
    const grid = () => document.querySelector(GRID);
    let pending = null;

    const markPills = (pathname) => {
      document.querySelectorAll('.filter-pill').forEach((pill) => {
        const active = new URL(pill.href, window.location.origin).pathname === pathname;

        pill.classList.toggle('filter-pill--active', active);

        if (active) {
          pill.setAttribute('aria-current', 'page');
        } else {
          pill.removeAttribute('aria-current');
        }
      });
    };

    const load = async (url, push) => {
      const target = grid();

      if (!target || !target.dataset.sectionId) return false;

      const controller = new AbortController();

      if (pending) pending.abort();
      pending = controller;

      target.setAttribute('aria-busy', 'true');

      try {
        const endpoint = new URL(url, window.location.origin);
        endpoint.searchParams.set('section_id', target.dataset.sectionId);

        const response = await fetch(endpoint, { signal: controller.signal });

        if (!response.ok) throw new Error(String(response.status));

        const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
        const next = parsed.querySelector(GRID);

        // A collection on a different template renders a different section, so
        // there may be nothing to swap in. Reporting failure hands the click
        // back to the browser instead of leaving the old products on screen.
        if (!next) throw new Error('missing grid');

        target.replaceWith(next);

        if (push) window.history.pushState({ collectionGrid: true }, '', url);

        markPills(new URL(url, window.location.origin).pathname);

        return true;
      } catch (error) {
        // A superseded request has already been replaced by a newer one, so it
        // must not trigger the fallback navigation.
        return error.name === 'AbortError';
      } finally {
        if (pending === controller) pending = null;

        const current = grid();

        if (current) current.removeAttribute('aria-busy');
      }
    };

    document.addEventListener('click', (event) => {
      const pill = event.target.closest('.filter-pill');

      if (!pill || !grid()) return;
      if (pill.origin !== window.location.origin) return;

      // Leave open-in-new-tab and middle-click alone.
      if (event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

      event.preventDefault();

      load(pill.href, true).then((swapped) => {
        if (!swapped) window.location.href = pill.href;
      });
    });

    // pushState does not fire on back and forward, so the grid has to be put
    // back by hand or the URL and the products fall out of step.
    window.addEventListener('popstate', () => {
      if (!grid()) return;

      load(window.location.href, false).then((swapped) => {
        if (!swapped) window.location.reload();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
  class ProductGallery extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-gallery-viewport]');

      if (!this.viewport) return;

      this.slides = Array.from(this.querySelectorAll('[data-gallery-slide]'));
      this.thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
      this.thumbRail = this.querySelector('[data-gallery-thumbs]');
      this.previous = this.querySelector('[data-gallery-previous]');
      this.next = this.querySelector('[data-gallery-next]');
      this.index = 0;

      this.update = this.update.bind(this);
      this.viewport.addEventListener('scroll', this.update, { passive: true });

      if (this.previous) this.previous.addEventListener('click', () => this.step(-1));
      if (this.next) this.next.addEventListener('click', () => this.step(1));

      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('click', () => this.goTo(Number(thumb.dataset.galleryThumb), true));
      });

      const initial = Number(this.dataset.initialIndex) || 0;

      if (initial > 0) {
        this.goTo(initial, false);
      } else {
        this.update();
      }
    }

    disconnectedCallback() {
      if (this.viewport) this.viewport.removeEventListener('scroll', this.update);
    }

    get reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    goTo(index, smooth) {
      const slide = this.slides[index];

      if (!slide) return;

      this.viewport.scrollTo({
        left: slide.offsetLeft - this.slides[0].offsetLeft,
        behavior: smooth && !this.reducedMotion ? 'smooth' : 'auto',
      });
    }

    step(direction) {
      this.goTo(Math.min(this.slides.length - 1, Math.max(0, this.index + direction)), true);
    }

    update() {
      const width = this.viewport.clientWidth;

      if (!width) return;

      const previous = this.index;
      this.index = Math.round(this.viewport.scrollLeft / width);

      this.thumbs.forEach((thumb, position) => {
        thumb.setAttribute('aria-selected', position === this.index ? 'true' : 'false');
      });

      if (this.index !== previous) {
        this.revealThumb();
        this.pauseHiddenVideos();
      }

      if (this.previous) this.previous.disabled = this.index === 0;
      if (this.next) this.next.disabled = this.index === this.slides.length - 1;
    }

    // Keeps the active thumbnail inside the rail without ever scrolling the
    // page, which scrollIntoView can do. Smoothness comes from the rail's own
    // scroll-behavior, so reduced motion is already handled in CSS.
    revealThumb() {
      const thumb = this.thumbs[this.index];

      if (!this.thumbRail || !thumb) return;

      const left = thumb.offsetLeft;
      const right = left + thumb.offsetWidth;

      if (left < this.thumbRail.scrollLeft) {
        this.thumbRail.scrollLeft = left;
      } else if (right > this.thumbRail.scrollLeft + this.thumbRail.clientWidth) {
        this.thumbRail.scrollLeft = right - this.thumbRail.clientWidth;
      }
    }

    // A video left playing off-screen keeps its audio going. Shopify-hosted
    // video renders a real <video>; an external YouTube or Vimeo embed is an
    // iframe and can only be paused through that provider's own API.
    pauseHiddenVideos() {
      this.slides.forEach((slide, position) => {
        if (position === this.index) return;

        slide.querySelectorAll('video').forEach((video) => {
          if (!video.paused) video.pause();
        });
      });
    }
  }

  if (!customElements.get('product-gallery')) {
    customElements.define('product-gallery', ProductGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["menu-drawer"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-menu-drawer-open]');

    if (opener) {
      const drawer = document.querySelector('[data-menu-drawer]');

      if (drawer && typeof drawer.showModal === 'function') {
        event.preventDefault();
        drawer.showModal();
      }

      return;
    }

    const closer = event.target.closest('[data-menu-drawer-close]');

    if (closer) {
      const drawer = closer.closest('[data-menu-drawer]');

      if (drawer) {
        drawer.close();
      }

      return;
    }

    if (event.target.matches('[data-menu-drawer]')) {
      event.target.close();
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  // The sort control submits on change, so the Apply button is only there for
  // visitors without JavaScript. Hiding it here rather than in CSS keeps that
  // no-JS path working.
  document.querySelectorAll('.search__sort').forEach((form) => {
    const select = form.querySelector('.search__sort-select');
    const submit = form.querySelector('.search__sort-submit');

    if (!select || !submit) return;

    submit.hidden = true;
    select.addEventListener('change', () => form.submit());
  });

  } catch(e) { console.error(e); }
})();
})();
